export const TEMPLATE_TYPE_ENUM = {
    consent: 'Consent',
    aftercare: 'Aftercare'
}

export const RES_PER_PAGE = 12;

export const MYFORMS_EMPTY_DESC = 'Start crafting a form that suits your needs.';
export const MYFORMS_EMPTY_SEARCH_RESULT_DESC = 'is not in your list.'